import React, { useState, useEffect } from 'react';
import { Form, Input, InputGroup, InputGroupAddon } from "reactstrap";
import useGlobal from '../../store';
import CurrencySymbol from '../General/CurrencySymbol';


const EditItemForm = (props) => {

    const [formState, setFormState] = useState({
        itemURLs: '',
        itemPic: '',
        itemName: '',
        itemDescription: '',
        itemPrice: 0,
        ...props.item
    });

    const [panelState] = useGlobal(
        state => state.ui.sidepanel.state
    );

    useEffect(() => {
        setFormState(panelState);
    }, [panelState]);

    const submitForm = async (event) => {
        event.preventDefault();
        console.log('submitting form...');
        const justFormData = new FormData(event.target);
        var object = {};
        justFormData.forEach((value, key) => {object[key] = value});
        const formData = { 
            itemID: formState.itemID,
            userID: formState.userID,
            itemName: formState.itemName,
            itemURLs: formState.itemURLs,
            itemPic: formState.itemPic,
            itemDescription: formState.itemDescription,
            itemPrice: formState.itemPrice
        };

        console.log('FORM DATA', formData);
        props.submitForm(formData);
    }

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formFields = { ...formState };
        formFields[name] = value;
        setFormState(formFields);
    }

    return (
        <Form onSubmit={submitForm} className="kt-form kt-form--label-right">
            <div className="form-group ">
                <label>Website link (URL)</label>
                <input type="text" className="form-control" placeholder="http://www..." name="itemURLs" value={formState.itemURLs || ''} onChange={handleInputChange} />
                    

            </div>
            
                <div className="form-group ">
                    <label>Item Name</label>
                    <input type="text" className="form-control" placeholder="Item Name" name="itemName" value={formState.itemName || ''} onChange={handleInputChange} />
                </div>

                <div className="form-group ">
                    <label>Item Image URL</label>
                    <div className="input-group">
                        <input type="text" className="form-control" placeholder="Item Image URL" name="itemPic" value={formState.itemPic || ''} onChange={handleInputChange} />
                        <div className="input-group-append">
                            <button className="btn btn-secondary" type="button">
                                <i className="flaticon-photo-camera"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="form-group ">
                    <label>Helpful details or notes</label>
                    <Input type="textarea" name="itemDescription" value={formState.itemDescription || ''} onChange={handleInputChange} />
                </div>

                <div className="form-group">
                    <label>Price</label>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend"><CurrencySymbol></CurrencySymbol></InputGroupAddon>
                        <Input placeholder="Amount" name="itemPrice" value={formState.itemPrice || '0'} onChange={handleInputChange} />
                    </InputGroup>
                </div>


                <div className="form-group">
                    <button className="btn btn-success btn-block" type="submit">Save Item</button>
                </div>
           

            
        </Form>);
}
export default EditItemForm;